import { render, staticRenderFns } from "./AppSearchResultItem.vue?vue&type=template&id=63ebb8fa&"
import script from "./AppSearchResultItem.vue?vue&type=script&lang=js&"
export * from "./AppSearchResultItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports